import React from "react";
import { Link } from "gatsby";

// ct
import { sendToCT } from "../../../services/Clevertap";

// components
import Carousel from "./Carousel";

//styles
import * as styles from "./SucessStories.module.css";

const SuccessStories = props => {
  return (
    <div className={props.bgColor ? props.bgColor : "bgLightgray"}>
      <div
        className={`container twinContainer ${styles.marginCo} ${
          props.bgColor + "Container"
        }`}
      >
        <div className="row ">
          {props.titleText ? (
            <div className="col-12 pb-3">
              <div className="col-md-6 col-11">
                <p className={styles.secondaryTxt}>{props.titleText}</p>
              </div>
            </div>
          ) : (
            <div className="col-12 pb-3">
              <p className="gradientText">Customer Success Stories</p>
            </div>
          )}

          <div className="col-12">
            <hr className={`${styles.darkHr}`} />
          </div>
          <div className="col-12 col-md-12 col-lg-12">
            <Carousel carouselId={props.carouselId} />
          </div>
          <div className="col-12 d-none d-md-block d-lg-block">
            <hr className={`${styles.darkHr}`} />
          </div>

          <div className={`col-12 ${props.bgColor + "Hide"}`}>
            <div className="d-inline-flex justify-content-center align-items-center pt-3 pb-2">
              <div className="transparentBtn">
                <Link
                  to="/testimonials"
                  className={`navLink`}
                  onClick={() =>
                    sendToCT("Customer_success_CTA2", {
                      action: "user clicks on view customer stories",
                    })
                  }
                >
                  <p className="pt-2 pb-2">View customer stories</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessStories;
